<span class="{{ setSize() }} text--purple">L</span
><span class="{{ setSize() }} text--pink">O</span
><span class="{{ setSize() }} text--dark-blue">M</span
><span class="{{ setSize() }} text--light-blue">Y</span>
